import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import Accordion from 'syf-component-library/ui/patterns/Accordion';
import { StyledFlex } from '../../../styles/common';
import { colors, spacing } from '../../../styles/theme';
export const StyledTermsAccordion = styled(Accordion) `
  border: 0;
  border-radius: 0;
  box-shadow: none;
  padding: ${spacing.base}px ${spacing.large}px ${spacing.base}px
    ${spacing.base}px;
  cursor: pointer;

  @media ${mediaQueries.lessThanLarge} {
    padding: ${spacing.xlarge}px ${spacing.large}px;
  }

  & > div[role='button'] {
    box-shadow: none;
    border-radius: 0;
    background-color: transparent;
    padding-bottom: ${spacing.medium}px;
    width: fit-content;
    border: 0;
    padding: 0;

    &:focus-visible {
      outline: 5px auto -webkit-focus-ring-color;
    }
  }

  & > div[role='button'] > header {
    color: ${colors.black};
  }

  & > div:nth-child(2) > div {
    padding: ${spacing.base}px 0 0;
  }
`;
export const StyledHeader = styled(StyledFlex) `
  border: none;
  cursor: pointer;
  background: none;
  padding: 0;
  color: ${colors.cyanBlue};

  @media ${mediaQueries.lessThanMedium} {
    width: 100%;
    justify-content: space-between;
  }
`;
//# sourceMappingURL=subcomponents.js.map